// Module
var code = "<div ng-class=\"'mm-loading ' + $ctrl.extraClasses\" ng-if=\"$ctrl.isLoading\"> <i class=\"fal fa-circle-notch fa-spin\"></i> <span>{{'Gui.Common.Loading' | translate}}</span> </div> ";
// Exports
var _module_exports = code;;
var path = '/App/Modules/Gui/Components/Indicators/Loading/Loading.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;